<template>
    <div class="w-100 h-100">
        <div class="row h-100">
            <div class="col-lg-12 d-flex flex-column h-100">
                <div class="np-group">
                    <div class="np-group np-group-column np-flex-1 np-pb-4">
                        <div class="np-header2  vertical-align-center np-pt-2 mb-4">
                            <svg class="np-mr-2"><use href="@/assets/images/icons/archive2.svg#icon"></use></svg> {{ $t("UI.archive.title") }}
                        </div>
                        <div class="np-group justify-content-start">
                            <div class="np-tabs np-mb-2">
                                <button :class="['np-tab np-nowrap', { active: currentMode === 'all' }]"@click="changeView('all')">
                                    <svg class="icon"><use href="@/assets/images/icons/archive-all.svg#icon"></use></svg> 
                                    <span>{{ $t("UI.archive.all") }}</span>
                                </button>
                                <button :class="['np-tab np-nowrap', { active: currentMode === 'tasks' }]"@click="changeView('tasks')">
                                    <svg class="icon"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg> 
                                    <span>{{ $t("UI.archive.tasks") }}</span>
                                </button>
                                <button :class="['np-tab np-nowrap', { active: currentMode === 'statuses' }]"@click="changeView('statuses')">
                                    <svg class="icon"><use href="@/assets/images/icons/statuses.svg#icon"></use></svg> 
                                    <span>{{ $t("UI.archive.statuses") }}</span>
                                </button>    
                                <button :class="['np-tab np-nowrap', { active: currentMode === 'projects' }]"@click="changeView('projects')">
                                    <svg class="icon"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> 
                                    <span>{{ $t("UI.archive.projects") }}</span>
                                </button>                                                                                     
                            </div>                
                        </div>  
                        <div class="np-group np-group-row pt-1">
                            <div class="np-field-group np-with-icon-right">
                                <input type="text" class="np-text-input np-outline" placeholder="Поиск" v-model="filters.name"/>
                                <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                            </div>                                                                      
                        </div>
                    </div>
                </div>
                <div class="np-panel np-flex-1 np-overflow-hidden">
                    <PerfectScrollbar>
                        <table class="np-table h-100">
                            <thead class="np-table-header">
                                <tr class="np-table-row">
                                    <th class="np-table-header-cell text-start np-color-primary-500" style="width: 44px;">
                                        <button class="np-btn-link np-color-primary-600" @click="onRowSelectAll">
                                            <svg v-if="selectedRows.length == rowsList.length" ><use href="@/assets/images/icons/checked4.svg#icon"></use></svg>
                                            <svg v-else><use href="@/assets/images/icons/task-incomplete.svg#icon"></use></svg>
                                        </button>
                                    </th>                                     
                                    <th class="np-table-header-cell" style="width: 25%;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.archive.name") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('name')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('name')" /> 
                                            </button>
                                        </div>
                                    </th>                                    
                                    <th class="np-table-header-cell" style="width: 15%;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.archive.date") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('date')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('date')" /> 
                                            </button>
                                        </div>
                                    </th>
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.archive.deletedFrom") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('deletedFrom')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('deletedFrom')" /> 
                                            </button>
                                        </div>
                                    </th>                                                          
                                    <th class="np-table-header-cell">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.archive.deletedWhom") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('deletedWhom')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('deletedWhom')" /> 
                                            </button>
                                        </div>
                                    </th>                                             
                                    <th class="np-table-header-cell" style="width: 96px;">
                                        <div class="np-group">
                                            <div class="flex-grow-1">{{ $t("UI.archive.files") }}</div>
                                            <button class="np-btn-link" @click="attachSorting('files')">
                                                <img class="np-ml-1 np-mr-1" :src="sortIcon('files')" /> 
                                            </button>
                                        </div>
                                    </th> 
                                    <th class="np-table-header-cell" style="width: 135px;">
                                    </th>                                                                                                                                                       
                                </tr>
                            </thead>
                            <tbody class="np-table-body">
                                <tr class="np-table-fixed-row" v-if="selectedRows.length > 0">
                                    <td colspan="11">
                                        <div class="np-group">
                                            <div class="np-group align-items-center np-flex-1">
                                                <button class="np-btn-link np-color-primary-600 ms-2 me-2" @click="onRowDeselectAll()">
                                                    <svg><use href="@/assets/images/icons/checked-uncheck-all.svg#icon"></use></svg>
                                                </button>
                                                <span>
                                                    Выбрано {{ selectedRows.length }} 
                                                </span>                                                
                                            </div>
                                            <div class="np-group align-items-center p-1">
                                                <button type="button" class="np-btn np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/unlock.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.lock") }}
                                                </button>                             
                                                <button type="button" class="np-btn np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/download.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.download") }}
                                                </button>                             
                                                <button type="button" class="np-btn np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/download.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.downloadAll") }}
                                                </button>                             
                                                <button type="button" class="np-btn np-danger np-outline me-3">
                                                    <svg class="icon"><use href="@/assets/images/icons/trash.svg#icon"></use></svg> 
                                                    {{ $t("UI.files.delete") }}
                                                </button>                                                                                                                                                                             
                                            </div>   
                                        </div>
                                    </td>
                                </tr>
                                <template v-for="row in rowsList">
                                    <tr class="np-table-row">
                                        <td class="np-table-cell">
                                            <div class="np-group align-items-center np-color-primary-600">
                                                <button class="np-btn-link np-color-primary-600" @click="onRowSelect(eFile.id)">
                                                    <svg v-if="row.selected" ><use href="@/assets/images/icons/checked4.svg#icon"></use></svg>
                                                    <svg v-else><use href="@/assets/images/icons/task-incomplete.svg#icon"></use></svg>
                                                </button>
                                            </div>
                                        </td>
                                        <td class="np-table-cell">
                                            <div class="np-group justify-content-between align-items-center" role="button" @click="showViewer(eFile.id)">
                                                <div class="flex-grow-1 np-ellipsis np-font-s">
                                                    {{ row.name }}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="np-table-cell">
                                            {{ row.taskTitle }}
                                        </td>
                                        <td class="np-table-cell text-center"></td>
                                        <td class="np-table-cell text-center"></td>
                                        <td class="np-table-cell"></td>
                                        <td class="np-table-cell">
                                            <div class="np-group">
                                                <button class="np-btn-link np-color-primary me-1"><svg><use href="@/assets/images/icons/unlock.svg#icon"></use></svg></button>
                                                <button class="np-btn-link np-color-danger"><svg><use href="@/assets/images/icons/trash.svg#icon"></use></svg></button>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>                                                                                         
                        </table>
                    </PerfectScrollbar>
                </div>
            </div>
        </div>            
    </div>
    <ViewerModal modalID="modalIDVwr" ref="VwrModal" />
    <DelModal modalID='modalIDelFile'  modalPosition="center" ref="DelFileModal" class="cobalt-base-dialog">
        <template v-slot:header-left>{{ deleteType.title }}</template>
        <template v-slot:body>
            <div class="modal-body">
                <h2>{{ $t("UI.confirmation") }}</h2>
            </div>
            <div class="modal-footer ps-0 pe-0">
                <button type="button" class="btn btn-outline-secondary btn-sm me-1"
                    data-bs-dismiss="modal">{{ $t("UI.close") }}</button>
                <button type="button" class="btn btn-danger btn-sm" @click="deleteAll">{{ $t("UI.delete") }}</button>
            </div>
        </template>
    </DelModal>    
</template>

<script>

import { localeDate, localeDateTime, formatBytes } from '@/utils/format'
import TaskCardSimple  from "@/components/TaskCardSimple.vue" 
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import CobaltProfile   from "@/components/dashboard/parts/CobaltProfile.vue"
import FilePreview from '@/components/elements/FilePreview.vue'
import ViewerModal from "@/components/modals/ViewerModal.vue"
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { mapGetters, mapActions } from 'vuex'
import Config from '../../../config.js'
import { confirm } from "@/utils/confirmation.js";

function compareValues(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { numeric: true })
  }
  if (a < b) return -1
  if (a > b) return 1
  return 0
}

function sortByMultipleFields(array, sorts) {
    return array.sort((a, b) => {

        const activeSorts = Object.entries(sorts)
        .filter(([field, direction]) => direction !== 'none')
        .map(([field, direction]) => ({ field, direction }))

        for (const { field, direction } of activeSorts) {
            const multiplier = direction === 'desc' ? -1 : 1

            let valueA, valueB
            if (field === 'status') {
                valueA = a.status.title
                valueB = b.status.title
            } else if (field === 'deadline') {
                valueA = daysTo(a.task.date_planned_end, a.task.date_actual_end)
                valueB = daysTo(b.task.date_planned_end, b.task.date_actual_end) 
            } else if (field === 'priority') {
                valueA = priorityTo(a.task.priority)
                valueB = priorityTo(b.task.priority)
            } else {                    
                valueA = a.task[field]
                valueB = b.task[field]
            }

            const result = compareValues(valueA, valueB)
            if (result !== 0) return result * multiplier
        }

        return 0
    })
}

export default {
    emits: ['showModTask', 'refresh'],
    components: {
        TaskCardSimple,
        CobaltProfile,
        VueSlider,
        IndicatorDaysTo,
        FilePreview,
        ViewerModal
    },
    props: {
        project: {
            type: Object,
            default: {}
        },      
        data: {
            type: Array,
            default: []
        },             
        users: {
            type: Array,
            default: []
        },            
        priorityValues: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            Config,
            currentMode: "all",
            compInfo: null,
            rowsFilter: '',
            filterVisible: false,
            filters: {
                name: '',
                date: null,                
                deletedFrom: '',
                deletedWhom: '',
                files: 0
            },
            sorts: {
                name: 'none',
                date: 'none',
                deletedFrom: 'none',
                deletedWhom: 'none',
                files: 'none'
            },
            selectedRows: [],
            fileToDelete: 0,
            deleteFromSubtask: false
        }
    },
    computed: {     
        rowsList: {
            get() {
                const searchTerm = this.filters.name.trim().toLowerCase()
                const fieldsToSearch = ['taskTitle', 'name']
                let list = []
                let usedSpace = 0

                // this.localStatuses.forEach(element => {
                //     element.tasks.forEach(taskItem => {
                //         taskItem.files.forEach(fileItem => {
                //             const selected = this.selectedRows.indexOf(fileItem.id) != -1
                //             let item = { "selected": selected, "statusId": element.id, "taskTitle": taskItem.title, "taskId": taskItem.id, "subTaskId": 0, ... fileItem }
                //             list.push(item)
                //             usedSpace += fileItem.fileSize
                //         })
                //         taskItem.subtask.forEach(subTaskItem => {
                //             subTaskItem.files.forEach(stFileItem => {
                //                 const selected = this.selectedRows.indexOf(stFileItem.id) != -1
                //                 let item = { "selected": selected, "statusId": element.id, "taskTitle": taskItem.title, "taskId": taskItem.id, "subTaskId": subTaskItem.id, ... stFileItem }
                //                 list.push(item)
                //                 usedSpace += stFileItem.fileSize
                //             })                            
                //         })
                //     })
                // })

                const sortedTasks = sortByMultipleFields(list, this.sorts)

                const result = sortedTasks.filter(item => {
                    return fieldsToSearch.some(field => 
                        String(item[field]).toLowerCase().includes(searchTerm)
                    )
                })

                return list
            }
        }       
    },
    methods: {
        ...mapActions('company', ['list']),
        ...mapGetters('company', ['getList']),     
        ...mapActions('board', ['deleteFile', 'deleteSubFile']),

        localeDate,
        localeDateTime,  
        formatBytes,       

        getPriority(task) {
            const priorityObj = this.priorityValues.find(option => option.value === task.priority)
            return priorityObj
        }, 
        sortIcon(field) {
            const direction = this.sorts[field]
            if (direction === 'asc') {
                return require('@/assets/images/icons/sort-asc.svg#icon')
            } else if (direction === 'desc') {
                return require('@/assets/images/icons/sort-desc.svg#icon')
            } else if (direction === 'none') {
                return require('@/assets/images/icons/sort-none.svg#icon')
            }
            return ''
        },
        attachSorting(field) {           
            if (!(field in this.sorts)) {
                console.error(`Поле "${field}" не существует в объекте sorts.`)
                return
            }

            Object.keys(this.sorts).forEach((key) => {
                if (key !== field) {
                    this.sorts[key] = 'none'
                }
            })
            
            const currentValue = this.sorts[field];

            if (currentValue === 'none') {
                this.sorts[field] = 'asc'
            } else if (currentValue === 'asc') {
                this.sorts[field] = 'desc'
            } else {
                this.sorts[field] = 'none'
            }
        },           
        showFilters() {
            this.filterVisible = !this.filterVisible
        }, 
        onRowSelect(id) {
            if (this.selectedRows.indexOf(id) != -1) {
                this.selectedRows = this.selectedRows.filter(_id => _id !== id)
            } else {
                this.selectedRows.push(id)
            }
        },
        onRowSelectAll() {
            if (this.selectedRows.length == this.rowsList.length) {
                this.selectedRows = []
            } else {
                this.selectedRows = []
                this.rowsList.forEach(item => {
                    this.selectedRows.push(item.id)
                })      
            }      
        },        
        onRowDeselectAll() {
            this.selectedRows = []
        },                    
        changeView(_mode) {
            this.currentMode = _mode
        },
        refresh() {
            this.$emit('refresh')
        }          
    }

}
</script>

<style scoped>
</style>